import { Point } from "../DrawingObj";
import { Element } from "./Element";
export class Line extends Element {
    constructor(element, retry = false) {
        var _a;
        super(element);
        if (this.element.AcDbLine) {
            this.points = [
                new Point(element.AcDbLine.VARS, 10),
                new Point(element.AcDbLine.VARS, 11),
            ];
        }
        if (this.element.AcDbPolyline) {
            this.points = [];
            for (let index = 0; index < this.element.AcDbPolyline.NumberOfVertices; index++) {
                this.points.push(new Point(element.AcDbPolyline.VARS, 10, index));
            }
        }
        if (this.element.AcDb2dPolyline) {
            this.points = this.element.Objects.filter((v) => v.named == "VERTEX").map((v) => {
                let p = new Point(v.AcDb2dVertex.VARS);
                if (v.AcDb2dVertex.Bulge)
                    p.Bulge = v.AcDb2dVertex.Bulge;
                return p;
            });
            this.element.Flag = (_a = this.element.AcDb2dPolyline.PolylineFlag) !== null && _a !== void 0 ? _a : null;
        }
        if (this.points.length <= 0) {
            this.points = [new Point(element.VARS, 10), new Point(element.VARS, 11)];
        }
        this.ExtrusionCheck();
    }
    length() {
        let totalLength = 0;
        for (let i = 1; i < this.points.length; i++) {
            const currentPoint = this.points[i];
            const previousPoint = this.points[i - 1];
            const dx = currentPoint.x - previousPoint.x;
            const dy = currentPoint.y - previousPoint.y;
            const segmentLength = Math.sqrt(dx * dx + dy * dy);
            totalLength += segmentLength;
        }
        return totalLength;
    }
}
